import Router from "../../App/Router";
import Page from "../../Layout/Page/Page";
import Section from "../../Sections/Section";

const LangSwitcher = {

    init(el) {
        el = el ? el : $('body');
        this.el = el.find('[component="LangSwitcher"]');
        if (!this.el.length) return;

        this.langs = this.el.find('.list a');
    },

    setUrl(urls) {
        // console.log('LangSwitcher.setUrl() --------------------------');
        // console.log('urls', urls);

        this.langs.each((i, el)=>{
            const lang = $(el).attr('lang');
            $(el).attr('href', "/" + urls[lang]);
            // console.log($(el), urls[lang])
        })
    },

    setByUrl() {
        // console.log('LangSwitcher.setByUrl() --------------------------', Section.current);
        let urls = {}
        if(!Section.current) return;

        const params = Router.params ? "/" + Router.params : "";

        if(Router.sectionUrl){
            urls = {
                en: Section.current.attr('en') + params,
                sk: Section.current.attr('sk') + params,
                si: Section.current.attr('si') + params
            }
            // console.log('with section', urls)
        } else {
            urls = {
                en: Page.el.attr('en'),
                sk: Page.el.attr('sk'),
                si: Page.el.attr('si')
            }
            // console.log('no section', urls)
        }

        this.setUrl(urls)
    }
}

export default LangSwitcher;